export const redirectURLActions = {
	__setURLLocationNRedirect: (
		{ redirectURLLocation: lastRedirectURLLocation },
		urlLocation,
		redirectURLLocation
	) => ({
		urlLocation,
		redirectURLLocation: !!redirectURLLocation
			? urlLocation
			: lastRedirectURLLocation,
	}),
};
